import { Component } from '@angular/core';
declare var $: any;
declare var jQuery:any;
declare var window:any;
@Component({
  selector: 'vt-login-layout',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class LoginLayoutComponent {
  ngAfterViewInit() {
      $('body').addClass('body-login');
      setTimeout(() => {
        document.getElementById("mainLoadingSpinnerID").classList.remove('show');
        document.getElementById("mainLoadingSpinnerID").classList.add('hide');
      }, 500);
    }
   
}